import React from "react";
import ContentWrapper from "../components/ContentWrapper";

const Accueil = () => {
  const currentYear = new Date().getFullYear();
  const logoSrc =
    process.env.REACT_APP_COMPANY === "provesta"
      ? "/Logo_H.png"
      : "/logo_cca.png";

  return (
    <ContentWrapper>
      <img src={logoSrc} className="rounded" alt="logo" style={{position: "absolute", left: '50%', top: '40%', transform: "translate(-50%, -50%)"}} />
      <span className="fixed-bottom-left">
        Droit d'auteur {currentYear} Tous droits réservés - Powered by{" "}
        <a href="https://provestasoft.com">ProvestaSoft</a>.
      </span>
      <div className="log_responsive">
        <a href="https://provestasoft.com">
          <img
            src={"/Logo_H.svg"}
            alt="logo"
            style={{ width: "100%", maxWidth: "100px", height: "auto" }}
          />
        </a>
      </div>
    </ContentWrapper>
  );
};

export default Accueil;
